<np-dialog
  [popupWidth]="1200"
  [popupTitle]="'Feldkonfiguration' | translate"
  [(popupVisible)]="visible"
>
  <div slot="content" class="w-100 h-100">
    <dx-scroll-view width="100%" height="100%" showScrollbar="always">
      <dx-tab-panel [dataSource]="excelPages" [(selectedIndex)]="excelIndex">
        <!--EXCEL FIELDS-->
        <div *dxTemplate="let company of 'excelFieldsTemplate'"
             class="{{ fullScreen ? 'exportExcelTabFullScreen' : 'exportExcelTab' }}">
          <fieldList [fields]="fields"
                     [defaultFields]="['GROUP_ID']"
                     [fieldGroups]="groups"
                     [(fieldListContainer)]="model"
                     [ngStyle]="{ height: 'inherit' }"></fieldList>
        </div>

        <div *dxTemplate="let company of 'miscTemplate'" class="{{ fullScreen ? 'exportTabFullScreen' : 'exportTab' }}">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">{{ 'Medien exportieren' | translate }}</div>
              <div class="dx-field-value">
                <dx-switch [(value)]="model.includeMime"></dx-switch>
              </div>
            </div>
            <div *ngIf="model.includeMime">
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Original verwenden' | translate }}</div>
                <div class="dx-field-value">
                  <dx-switch [(value)]="model.orignialSize"></dx-switch>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Quadratische Ansicht' | translate }}</div>
                <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                  <label class="placeLabel {{ imageSquared ? 'placeLabelSmall' : '' }}">SQUARE IMAGE</label>
                  <dx-switch [(value)]="model.imageSquared"></dx-switch>
                </div>
              </div>
              <div class="dx-field" *ngIf="model.imageSquared">
                <div class="dx-field-label">{{ 'Hintergrundfarbe wählen' | translate }}</div>
                <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                  <label class="placeLabel {{ imageBgColor ? 'placeLabelSmall' : '' }}">BACKGROUND COLOR</label>
                  <dx-color-box [(value)]="model.imageBgColor"></dx-color-box>
                </div>
              </div>
            </div>
            <div *ngIf="!model.orignialSize">
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Maximale Seitenlänge' | translate }}</div>
                <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                  <label class="placeLabel {{ model.maxResolution > 0 ? 'placeLabelSmall' : '' }}">
                    MAX RESOLUTION
                  </label>
                  <dx-number-box [min]="16"
                                 [max]="8192"
                                 [(value)]="model.maxResolution"
                                 [showClearButton]="true"></dx-number-box>
                </div>
              </div>
              <div class="dx-field">
                <div class="dx-field-label">{{ 'Dateityp' | translate }}</div>
                <div class="dx-field-value {{ showPlaceHolders ? 'inputWithPlaceHolder' : 'inputWithOutPlaceHolder' }}">
                  <label class="placeLabel {{ model.imageType?.length > 0 ? 'placeLabelSmall' : '' }}">FILE TYPE</label>
                  <dx-select-box [(value)]="model.imageType" [items]="imageTypes" placeholder=""></dx-select-box>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *dxTemplate="let company of 'ftpTemplate'" class="{{ fullScreen ? 'exportTabFullScreen' : 'exportTab' }}">
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">
                FTP Server
              </div>
              <div class="dx-field-value">
                <dx-lookup [dataSource]="ftpServers"
                           valueExpr="id"
                           displayExpr="name"
                           [(value)]="model.ftpServerId" />
              </div>
            </div>
          </div>
        </div>
</dx-tab-panel>
    </dx-scroll-view>

    <np-dialog-button *ngIf="!workflowMode"
                      slot="toolbar"
                      toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ text: 'Excel exportieren' | translate, onClick: exportExcel }"></np-dialog-button>
    <np-dialog-button *ngIf="!workflowMode &&loginService.hasAddonCSV"
                      slot="toolbar"
                      toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ text: 'CSV exportieren' | translate, onClick: exportCSV }"></np-dialog-button>
    <np-dialog-button *ngIf="workflowMode"
                      slot="toolbar"
                      toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ text: 'Excel Speichern' | translate, onClick: saveModel }"></np-dialog-button>
    <np-dialog-button *ngIf="workflowMode &&loginService.hasAddonCSV"
                      slot="toolbar"
                      toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ text: 'CSV Speichern' | translate, onClick: saveModelCSV }"></np-dialog-button>
    <np-dialog-button slot="toolbar"
                      toolbar="bottom"
                      location="after"
                      widget="dxButton"
                      [options]="{ icon: 'revert', onClick: reset }"></np-dialog-button>
  </div>
</np-dialog>
